import React from 'react';

const FreeReturns = ({ ...props }) => {
    return (
        <svg
            width="65"
            height="64"
            viewBox="0 0 65 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.9497 32.0019L13.9497 54L10.5 32.0019L10.5 31.9981L13.9497 10L13.9497 32.0019ZM19.8578 32.0019L19.8578 54L13.9497 32.0019L19.8578 10L19.8578 32.0019ZM19.8578 32.0019L31.6886 10L31.6886 54L19.8578 32.0019ZM31.6886 32.0019L54.5 10L54.5 54L31.6886 32.0019Z"
                fill="#222222"
            />
        </svg>
    );
};

export default FreeReturns;
